// extracted by mini-css-extract-plugin
module.exports = {"addressField":"AddressDisplay_addressField__Ua_PG","addressFieldTitle":"AddressDisplay_addressFieldTitle__1HB9R","compact":"AddressDisplay_compact__3zapE"};